'use client';

import { useState, useEffect } from 'react';
import { CURRENT_USER, hasPermission, canAccess, ROLE_LABELS, ROLE_COLORS } from './rbac';
import type { Permission, UserRole, UserProfile } from './rbac';

function getSessionUser(): UserProfile {
  if (typeof window === 'undefined') return CURRENT_USER;
  try {
    const raw = sessionStorage.getItem('auth_user');
    if (raw) {
      const parsed = JSON.parse(raw) as UserProfile;
      if (parsed && parsed.role) return parsed;
    }
  } catch {
    // ignore parse errors
  }
  return CURRENT_USER;
}

export function useRole() {
  const [user, setUser] = useState<UserProfile>(CURRENT_USER);

  useEffect(() => {
    setUser(getSessionUser());
  }, []);

  const role: UserRole = user.role;

  return {
    user,
    role,
    roleLabel: ROLE_LABELS[role],
    roleColors: ROLE_COLORS[role],
    can: (permission: Permission) => hasPermission(role, permission),
    canNav: (navId: string) => canAccess(role, navId),
    isFarmOwner: role === 'farm_owner',
    isManager: role === 'manager',
    isTechnician: role === 'technician',
    isFieldStaff: role === 'field_staff',
    isManagerOrAbove: role === 'farm_owner' || role === 'manager',
  };
}
